import clsx from 'clsx';
import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';

import { AtomButton } from '../Button';
import { Tooltip, type TooltipProps } from '../Tooltip';

/**
 * An InsertLineButton is a custom button intended to be used as a visual affordance to insert something in-place when pressed.
 *
 * It is intended to be used outside the flow of the document to avoid it taking space in the document.
 * Note that it is not `absolute` by default, but intended to be used in that way. Pass
 * `className="absolute <top/bottom/left/right>"` to position it for your specific usecase.
 */
export const InsertLineButton = ({
    onPress,
    className,
    tooltip,
}: {
    onPress: () => void;
    className?: string;
    tooltip: TooltipProps['label'];
}): React.ReactElement => {
    return (
        <Tooltip label={tooltip}>
            <AtomButton
                onPress={onPress}
                className={clsx(
                    'group/insert-area z-10 flex h-4 w-full items-center justify-center opacity-0 hover:opacity-100',

                    // Full-width line shown below the +
                    "before:absolute before:right-0 before:left-0 before:h-0.5 before:origin-center before:rounded-xl before:bg-standout-on-base before:transition-all before:content-['']",
                    // Transition of the line
                    'before:scale-x-75 before:opacity-0 before:duration-500 before:ease-snappy-out hover:before:scale-x-100 hover:before:opacity-100',
                    className
                )}
                contentEditable={false}
            >
                <div className="z-20 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white border-solid bg-tile-inverted dark:border-black">
                    <Icon.Plus size={16} className="text-white dark:text-black" />
                </div>
            </AtomButton>
        </Tooltip>
    );
};
